export const RULE_TYPE = [
    { label: 'Trusted Requestor', value: 'Trusted Requestor' },
    { label: 'Max Order Amount', value: 'Max Order Amount' },
    { label: 'Catalog', value: 'Catalog' },
];

export const RULE_TYPE_NAME = {
    TRUSTED_REQUESTOR: 'Trusted Requestor',
    BUDGET_AMOUNT: 'Max Order Amount',
    CATALOG: 'Catalog',
};

export default {};
